"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaDemographicsResultFactory = void 0;
const Factory = require("factory.ts");
const Profiles_1 = require("../Profiles");
exports.personaDemographicsResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    persona: Profiles_1.personaFactory.build(),
    demographics: Profiles_1.PersonaDemographicsFactory.build(),
});
